import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/half_time_refreshments_banner.webp";

const HalfTimeRefreshmentsModal = ({ serialNumber, onClose, onPlay, onVideoEnded }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Half-Time Refreshments"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "You will have access to a dedicated concession point offering a complimentary selection of snacks and drinks at half time."
              }
            </p>
            <p>
              {
                "Scan your wristband to grant you access to this benefit. No credit will be taken from your shopping allowance.​"
              }
            </p>
          </div>
          <div className="section bg-black">
            <video
              src={
                "https://s3.eu-west-2.amazonaws.com/www.digiseq.co.uk/mastercard/mastercard+Half-Time+Concession_2.mp4"
              }
              playsInline
              preload="auto"
              controls
              onPlay={() => onPlay()}
              onEnded={() => onVideoEnded()}
            />
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default HalfTimeRefreshmentsModal;
